// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.doc-form {
  width: 100%;
  min-width: 0;
}

.doc-form__field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.doc-form__label {
  margin: 0 0 6px;
  font-size: 13px;
  font-weight: 500;
  color: #334155;
  line-height: 1.3;
}

.doc-form__req {
  color: #F43F5E;
  font-weight: 600;
}

.doc-form__hint {
  margin: 6px 0 0;
  font-size: 12px;
  line-height: 1.45;
  color: #94A3B8;
}

.doc-form .ant-form-item {
  margin-bottom: 0 !important;
}

.doc-form .ant-form-item-label,
.doc-form .ant-form-item-feedback-icon {
  display: none !important;
}

.doc-form .ant-form-item-control-input {
  min-height: 36px !important;
}

.doc-form .ant-form-item-explain-error {
  font-size: 12px;
  margin-top: 4px;
}

.doc-form .ant-input-affix-wrapper,
.doc-form .ant-form-item-control-input-content > input.ant-input {
  box-sizing: border-box !important;
  width: 100% !important;
  height: 36px !important;
  min-height: 36px !important;
  margin: 0 !important;
  padding: 0 12px !important;
  border: 1px solid #E2E8F0 !important;
  border-radius: 8px !important;
  background: #ffffff !important;
  box-shadow: none !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  color: #1E293B !important;
}

.doc-form .ant-input-affix-wrapper input.ant-input {
  height: 100% !important;
  min-height: 0 !important;
  padding: 0 !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
}

.doc-form .ant-form-item-control-input-content > input.ant-input::placeholder {
  color: #94A3B8;
  font-weight: 400;
}

.doc-form .ant-input-affix-wrapper:hover,
.doc-form .ant-form-item-control-input-content > input.ant-input:hover {
  border-color: #CBD5E1 !important;
}

.doc-form .ant-input-affix-wrapper-focused,
.doc-form .ant-input-affix-wrapper:focus-within,
.doc-form .ant-form-item-control-input-content > input.ant-input:focus {
  border-color: #0EA5E9 !important;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.2) !important;
}

.doc-form .ant-form-item-has-error .ant-input-affix-wrapper,
.doc-form .ant-form-item-has-error .ant-form-item-control-input-content > input.ant-input {
  border-color: #F43F5E !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/forms/accounting/documents/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,iCAAiC;EACjC,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;EACpB,0BAA0B;EAC1B,oCAAoC;EACpC,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;;EAGE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;;EAEE,gCAAgC;AAClC","sourcesContent":[".doc-form {\n  width: 100%;\n  min-width: 0;\n}\n\n.doc-form__field {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.doc-form__label {\n  margin: 0 0 6px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #334155;\n  line-height: 1.3;\n}\n\n.doc-form__req {\n  color: #F43F5E;\n  font-weight: 600;\n}\n\n.doc-form__hint {\n  margin: 6px 0 0;\n  font-size: 12px;\n  line-height: 1.45;\n  color: #94A3B8;\n}\n\n.doc-form .ant-form-item {\n  margin-bottom: 0 !important;\n}\n\n.doc-form .ant-form-item-label,\n.doc-form .ant-form-item-feedback-icon {\n  display: none !important;\n}\n\n.doc-form .ant-form-item-control-input {\n  min-height: 36px !important;\n}\n\n.doc-form .ant-form-item-explain-error {\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.doc-form .ant-input-affix-wrapper,\n.doc-form .ant-form-item-control-input-content > input.ant-input {\n  box-sizing: border-box !important;\n  width: 100% !important;\n  height: 36px !important;\n  min-height: 36px !important;\n  margin: 0 !important;\n  padding: 0 12px !important;\n  border: 1px solid #E2E8F0 !important;\n  border-radius: 8px !important;\n  background: #ffffff !important;\n  box-shadow: none !important;\n  font-size: 13px !important;\n  font-weight: 400 !important;\n  line-height: 1.5 !important;\n  color: #1E293B !important;\n}\n\n.doc-form .ant-input-affix-wrapper input.ant-input {\n  height: 100% !important;\n  min-height: 0 !important;\n  padding: 0 !important;\n  border: none !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  background: transparent !important;\n}\n\n.doc-form .ant-form-item-control-input-content > input.ant-input::placeholder {\n  color: #94A3B8;\n  font-weight: 400;\n}\n\n.doc-form .ant-input-affix-wrapper:hover,\n.doc-form .ant-form-item-control-input-content > input.ant-input:hover {\n  border-color: #CBD5E1 !important;\n}\n\n.doc-form .ant-input-affix-wrapper-focused,\n.doc-form .ant-input-affix-wrapper:focus-within,\n.doc-form .ant-form-item-control-input-content > input.ant-input:focus {\n  border-color: #0EA5E9 !important;\n  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.2) !important;\n}\n\n.doc-form .ant-form-item-has-error .ant-input-affix-wrapper,\n.doc-form .ant-form-item-has-error .ant-form-item-control-input-content > input.ant-input {\n  border-color: #F43F5E !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
